var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{attrs:{"primary":""},on:{"click":_vm.create}},[_vm._v(" Add funnel stage ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }